import { render, staticRenderFns } from "./ProductAdditionRequests.html?vue&type=template&id=4f6f13ed&external"
import script from "./ProductAdditionRequests.js?vue&type=script&lang=js&external"
export * from "./ProductAdditionRequests.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports